export default class CobrancasRecorrentesController {
  constructor(resource) {
    this._resource = resource;
  }

  getRecurrent() {
    return this._resource('recorrentes')
      .get()
      .then(res => res.body)
      .catch(error => console.log(error));
  }

  getRecurrentFilterByClients(clientsSelected, recurrentPackageSelected) {
    return this._resource('recorrentes/filter')
      .get({ clients: clientsSelected, recurrentType: recurrentPackageSelected })
      .then(res => res.body)
      .catch(error => console.log(error));
  }

  cancelRecurrent(cobrancaRecorrenteId) {
    return this._resource('recorrente/cancel')
      .update({ cobrancaRecorrenteId })
      .then(res => res.body);
  }

  renewRecurrent(cobrancaRecorrenteId) {
    return this._resource('recorrente/renovacao')
      .save({ id: cobrancaRecorrenteId })
      .then(res => res.body);
  }

  recurringBalance(promotionUserId) {
    return this._resource(`recurring-balance/${promotionUserId}`)
      .get()
      .then(res => res.body)
      .catch(error => console.log(error));
  }

  updateCreditCard(data) {
    return this._resource('recorrente/credit-card')
      .update(data)
      .then(res => res.body)
      .catch(error => console.log(error));
  }

  verifyMulct(id) {
    return this._resource(`recorrente/verify-mulct/${id}`)
      .get()
      .then(res => {
        return res.body;
      })
      .catch(error => console.log(error));
  }

  newCancelRecurrent(id, cobrarMulta) {
    return this._resource('recorrente/new-cancel')
      .update({ cobrarMulta, id })
      .then(res => res.body);
  }

  requestPlanMigration(data) {
    return this._resource('recorrente/plan-migration')
      .update(data)
      .then(res => res.body)
      .catch(error => {
        console.log(error);
        throw error;
      });
  }
}
